var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcPlusInCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#3AB2BF",
  clipPath: "url(#ic-plus-in-circle_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7 .875A6.13 6.13 0 0 1 13.125 7 6.13 6.13 0 0 1 7 13.125 6.13 6.13 0 0 1 .875 7 6.13 6.13 0 0 1 7 .875M7 0C3.133 0 0 3.133 0 7s3.133 7 7 7 7-3.133 7-7-3.133-7-7-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.52 4.365v2.077h2.064c.268 0 .397.21.397.467 0 .256-.129.478-.397.478H7.52v2.252c0 .303-.245.443-.513.443-.269 0-.525-.14-.525-.443V7.387H4.416c-.269 0-.397-.21-.397-.478 0-.269.128-.467.397-.467H6.48V4.365c0-.303.256-.443.525-.443.268 0 .513.14.513.443"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-plus-in-circle_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h14v14H0z"
})))));
export default SvgIcPlusInCircle;